import i18n from "shared/i18n";

/** 
    When translations are used within a React component, React can automatically re-render the component 
    when the translations are loaded, ensuring that the component displays the correct translated content.
    In contrast, plain JavaScript files outside of React components do not have this built-in reactivity. 
    Therefore, withTranslations will load translations and use them in plain JavaScript files.
 */

export function withTranslations(ns, func) {
  return (args) => {
    i18n.loadNamespaces(ns, () => {
      i18n.changeLanguage(i18n.language, () => {
        return func(args);
      });
    });
  };
}
